import SingleSelectQuestionTemplate from '~/pages/anatomyV2/libs/components/SingleSelectQuestionTemplate'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 6

const FocusGoalAnatomyV2 = (props: TPageProps) => (
  <SingleSelectQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.focusGoal.title"
    options={[
      {
        key: 'buildDeepFocusHabit',
        i18nKey: 'onboarding.focusGoal.options.buildDeepFocusHabit',
      },
      {
        key: 'stayFocusedAtWork',
        i18nKey: 'onboarding.focusGoal.options.stayFocusedAtWork',
      },
      {
        key: 'finishTasksWithoutDistractions',
        i18nKey: 'onboarding.focusGoal.options.finishTasksWithoutDistractions',
      },
    ]}
    question="What is your focus goal?"
  />
)

export default FocusGoalAnatomyV2
